<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-9 col-12">
        <div class="mt-4 card card-body">
          <h6 class="mb-0">Funcionário x Folha</h6>
          <hr class="my-4 horizontal dark" />

          <!--Periodo-->
          <div v-if="isMobile" class="mt-0 row">
            <div class="col-12">
              <label class="form-label">Data Inicial</label>
              <flat-pickr id="data-inicial" v-model="datai" class="form-control datetimepicker"
                placeholder="--/--/----" :config="config"></flat-pickr>
            </div>
            <div class="col-12">
              <label class="form-label">Data Final</label>
              <flat-pickr id="data-final" v-model="dataf" class="form-control datetimepicker"
                placeholder="--/--/----" :config="config"></flat-pickr>
            </div>
            <div><p></p></div>
            <!--Seleção-->
            <div class="col-4 text-center">
              <h6>Seleção</h6>
              <RadioButton
                id="competencia"
                name="selecao"
                value="competencia"
                label="Competen."
                v-model="selectedStatus"
              />
              <RadioButton
                id="admissao"
                name="selecao"
                value="admissao"
                label="Admissão"
                v-model="selectedStatus"
              />
              <RadioButton
                id="demissao"
                name="selecao"
                value="demissao"
                label="Demissão"
                v-model="selectedStatus"
              />
            </div> 

            <!--Situação-->
            <div class="col-4 text-center">
              <h6>Situação</h6>
              <RadioButton
                id="ativo"
                name="situacao"
                value="ativo"
                label="Ativo"
                v-model="selectedSituacao"
              />
              <RadioButton
                id="inativo"
                name="situacao"
                value="inativo"
                label="Inativo"
                v-model="selectedSituacao"
              />
              <RadioButton
                id="todos1"
                name="situacao"
                value="todos1"
                label="Todos"
                v-model="selectedSituacao"
              />
            </div> 

            <!--Regime-->
            <div class="col-4 text-center">
              <h6>Regime</h6>
              <RadioButton
                id="clt"
                name="regime"
                value="clt"
                label="Clt"
                v-model="selectedRegime"
              />
              <RadioButton
                id="outros"
                name="regime"
                value="outros"
                label="Outros"
                v-model="selectedRegime"
              />
              <RadioButton
                id="todos2"
                name="regime"
                value="todos2"
                label="Todos"
                v-model="selectedRegime"
              />
            </div> 
            <div class="col-12 d-flex align-items-center justify-content-center">
              <button v-on:click="pesquisar()"
                type="button"
                name="button"
                class="m-4 btn bg-gradient-primary ms-1"
              >
              <i class="fas fa-magnifying-glass"> </i>  Pesquisar
              </button>
            </div>
          </div>
          <!--FIM DIV-->

          <!--Periodo 2-->
          <div v-else class="mt-0 row">
            <div class="col-4">
              <label class="form-label">Data Inicial</label>
              <flat-pickr id="data-inicial" v-model="datai" class="form-control datetimepicker"
                placeholder="--/--/----" :config="config"></flat-pickr>
            </div>
            <div class="col-4">
              <label class="form-label">Data Final</label>
              <flat-pickr id="data-final" v-model="dataf" class="form-control datetimepicker"
                placeholder="--/--/----" :config="config"></flat-pickr>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-center">
              <button v-on:click="pesquisar()"
                type="button"
                name="button"
                class="m-3 btn bg-gradient-primary ms-1"
              >
              <i class="fas fa-magnifying-glass"> </i> Pesquisar
              </button>
            </div>

            <hr class="my-4 horizontal dark" />
            <!--Seleção-->
            <div class="col-4 text-center">
              <h6>Seleção</h6>
              <RadioButton
                id="competencia"
                name="selecao"
                value="competencia"
                label="Competência"
                v-model="selectedStatus"
              />
              <RadioButton
                id="admissao"
                name="selecao"
                value="admissao"
                label="Admissão"
                v-model="selectedStatus"
              />
              <RadioButton
                id="demissao"
                name="selecao"
                value="demissao"
                label="Demissão"
                v-model="selectedStatus"
              />
            </div> 

            <!--Situação-->
            <div class="col-4 text-center">
              <h6>Situação</h6>
              <RadioButton
                id="ativo"
                name="situacao"
                value="ativo"
                label="Ativo"
                v-model="selectedSituacao"
              />
              <RadioButton
                id="inativo"
                name="situacao"
                value="inativo"
                label="Inativo"
                v-model="selectedSituacao"
              />
              <RadioButton
                id="todos1"
                name="situacao"
                value="todos1"
                label="Todos"
                v-model="selectedSituacao"
              />
            </div> 

            <!--Regime-->
            <div class="col-4 text-center">
              <h6>Regime</h6>
              <RadioButton
                id="clt"
                name="regime"
                value="clt"
                label="Clt"
                v-model="selectedRegime"
              />
              <RadioButton
                id="outros"
                name="regime"
                value="outros"
                label="Outros"
                v-model="selectedRegime"
              />
              <RadioButton
                id="todos2"
                name="regime"
                value="todos2"
                label="Todos"
                v-model="selectedRegime"
              />
            </div> 
          </div>
          <!--FIM DIV-->

          <!--GRID DE FOLHA 1 -->
          <div class="row mt-2">
            <div class="col-12">
              <grid-funcx-folha :folha1="folha1"/>
            </div>
          </div>

          <hr class="my-4 horizontal dark" />

         <!--GRID DE FOLHA 2 -->
          <div class="row mt-2">
            <div class="col-12">
              <grid-funcx-folha-2 :folha2="folha2"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/l10n/pt.js"; 
import GridFuncxFolha from "./components/GridFuncxFolha.vue"; 
import GridFuncxFolha2 from "./components/GridFuncxFolha2.vue"; 
import RadioButton from "./components/RadioButton.vue";
import API_URL from "../../api.js"
import Choices from "choices.js";
import Quill from "quill"; 
import {mask} from 'vue-the-mask';
import { mapMutations } from "vuex";
import { format } from 'date-fns';
import { decryptData } from '../../api.js';



export default {
  name: "FuncxFolha", 
  directives: {
    mask
  },
  components: {
    GridFuncxFolha,
    GridFuncxFolha2,
    flatPickr,
    RadioButton
  },
  data() {
    return {  
      isMobile: '',
      selectedStatus: 'competencia',
      selectedSituacao: 'ativo',
      selectedRegime: 'clt',
      teste: [{}],
      folha1: [{}],
      folha2: [{}],
      datai: '',
      dataf: '',
      config: {
        allowInput: true,
        locale: 'pt',
        dateFormat: 'd/m/Y',
        defaultDate: new Date()
      },
    };
  },
  methods: {   
    ...mapMutations(["navbarMinimize","navbarMaximize", "toggleConfigurator"]),
    toggleNavigationOnMobile() {
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      }
    }, 
    formataData(data){
      const datae = data.toString()
      let primeiraBarra =  datae.indexOf("/");
      let dia = datae.slice(0,primeiraBarra)
      let semDia = datae.slice(primeiraBarra+1,datae.length)
      let segundaBarra = semDia.indexOf("/");
      let mes = semDia.slice(0,segundaBarra)
      let ano = semDia.slice(segundaBarra+1,semDia.length)
      return  `${ano}-${mes}-${dia}`;
    },
    pesquisar(){
      //console.log(decryptData(localStorage.token));
      localStorage.token ? console.log("Existe Token") : this.$route.path.split("/authentication/signin/basic")

      this.$swal({
      title: "pesquisando...",
      didOpen: () => {
      //console.log(this.datai);  
      this.$swal.showLoading();
      var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", "Bearer "+decryptData(localStorage.token));

       var requestOptions = {
           method: 'GET',
           headers: myHeaders,
           //body: raw,
           redirect: 'follow'
        };

        this.folha2 = [{
            cod: 1,
            cargo: 'Caixa',
            lojas: [{
              lj0: '1',
              lj1: '2',
              lj2: '0'
            }],
            total: 3
        },{
            cod: 21,
            cargo: 'analista',
            lojas: [{
              lj0: '1',
              lj1: '2',
              lj2: '0'
            }],
            total: 3
        },{
            cod: 35,
            cargo: 'engenheiro',
            lojas: [{
              lj0: '1',
              lj1: '2',
              lj2: '0'
            }],
            total: 3
        }];

      console.log("datai: "+this.formataData(this.datai)+" dataf: "+this.formataData(this.dataf))
      fetch(API_URL+'vendedordes?datai='+this.formataData(this.datai)+'&dataf='+this.formataData(this.dataf), requestOptions)
       .then(response => response.json())
       //.then(result => {/*console.log("Result: "+JSON.stringify(result)),*/this.folha1=result,this.$swal.close()})
       .then(result => {
          this.teste = result,
          this.folha1 = [{
            ljt: 0,
            ljr: 0,
            codigo: 17717,
            matr: 50,
            nome: 'Gustavo Oliveira',
            admissao: '01/10/2022',
            e1: '',
            dtexp1: '',
            f1: '',
            e2: '',
            dtexp2: '',
            f2: '',
            demissao: '',
            salario: '1000,00',
            cargo: 'analista',
            ativo: 'S'
          },
          {
            ljt: 1,
            ljr: 1,
            codigo: 15212,
            matr: 35,
            nome: 'João Silva',
            admissao: '04/06/2021',
            e1: '',
            dtexp1: '',
            f1: '',
            e2: '',
            dtexp2: '',
            f2: '',
            demissao: '',
            salario: '1000,00',
            cargo: 'engenheiro',
            ativo: 'S'
          },
          {
            ljt: 1,
            ljr: 1,
            codigo: 18008,
            matr: 77,
            nome: 'Carlos Santos',
            admissao: '08/02/2023',
            e1: '',
            dtexp1: '',
            f1: '',
            e2: '',
            dtexp2: '',
            f2: '',
            demissao: '10/09/2023',
            salario: '1000,00',
            cargo: 'crediario',
            ativo: 'N'
          }];
          //this.folha1 = JSON.parse(this.folha1)
          console.log("Resultado Folha: "+ JSON.stringify(this.folha1))
          this.$swal.close()})
       .catch(error => console.log('error', error));
      }
    })
    },
    clearForm() {
    const defaultData = {  
      orcamentos: [
        {}
      ],
      config: {
        allowInput: true,
        locale: 'pt',
        dateFormat: 'd/m/Y'
      },
      // adicione aqui outras variáveis do seu estado que precisam ser limpas
    }
    Object.assign(this.$data, defaultData);
    }, 
  },
  created() { 
    console.log("created")
  },
  mounted() {
    this.isMobile = window.innerWidth < 576
    this.datai = format(new Date(),'dd/MM/yyyy')
    this.dataf = format(new Date(),'dd/MM/yyyy')
    this.pesquisar();

    if (document.getElementById("editor")) {
      new Quill("#editor", {
        theme: "snow", // Specify theme in configuration
      });
    }

    if (document.getElementById("choices-multiple-remove-button")) {
      var element = document.getElementById("choices-multiple-remove-button");
      const example = new Choices(element, {
        removeItemButton: true,
        allowHTML: true,
      });

      example.setChoices(
        [
          {
            value: "One",
            label: "Label One",
            disabled: true,
          },
          {
            value: "Two",
            label: "Label Two",
            selected: true,
          },
          {
            value: "Three",
            label: "Label Three",
          },
        ],
        "value",
        "label",
        false
      );
    }
  },
  computed: { 
  }
}
</script>  

<style>
  .form-control.error{
    border-color: red;
  }

  .form-control.datetimepicker.error{
    border-color: red;
  }
</style>
 